/**
 *
 */
class Product {
    /**
     * 
     */
    constructor() {
        this.type = 'food';
        this.code = '';
        this.brand = '';
        this.name = '';
        this.amount = 1;
        this.quantity = 0;
        this.unit = 'g';
        this.nutrients = [];
        this.ingredients = [];
        this.traces = [];
        this.stores = [];
        this.labels = [];
        this.images = [];
    }
    
    /**
     *
     */
    Init(
        type,
        code,
        brand,
        name,
        amount,
        quantity,
        unit,
        nutrients,
        ingredients,
        traces,
        stores,
        labels,
        images
    ) {

    }

    /**
     *
     * @param productObject
     * @constructor
     */
    InitFromProductObject(productObject) {

    }

    /**
     *
     * @param queueObject
     * @constructor
     */
    InitFromQueueObject(queueObject) {

    }

    /**
     *
     * @param formData
     * @constructor
     */
    InitFromFormData(formData) {
        for(let result of formData.entries()) {
            // skip empty values
            if('' === result[1]) {
                continue;
            }

            switch (result[0]) {
                case 'nutrients[]': this.nutrients.push({'name': result[1], 'proportion': ''}); break;
                case 'nutrients_percentage[]': this.nutrients[this.nutrients.length - 1].proportion = result[1].replace(',', '.'); break;
                case 'ingredients[]': this.ingredients.push({'name': result[1], 'rank': this.ingredients.length + 1, 'proportion': ''}); break;
                case 'ingredients_percentage[]': this.ingredients[this.ingredients.length - 1].proportion = result[1].replace(',', '.'); break;
                case 'traces[]': this.traces.push({'name': result[1]}); break;
                case 'stores[]': this.stores.push({'name': result[1]}); break;
                case 'labels[]': this.labels.push({'name': result[1]}); break;
                case 'images[]': this.images.push({'language': '', 'type': '', 'size': '', 'width': '', 'height': '', 'url': result[1]}); break;
                case 'images_language[]': this.images[this.images.length - 1].language = result[1]; break;
                case 'images_type[]': this.images[this.images.length - 1].type = result[1]; break;
                case 'images_size[]': this.images[this.images.length - 1].size = result[1]; break;
                case 'images_width[]': this.images[this.images.length - 1].width = result[1]; break;
                case 'images_height[]': this.images[this.images.length - 1].height = result[1]; break;
                case 'type': this.type = result[1]; break;
                case 'code': this.code = result[1]; break;
                case 'brand': this.brand = result[1]; break;
                case 'name': this.name = result[1]; break;
                case 'amount': this.amount = result[1]; break;
                case 'quantity': this.quantity = result[1]; break;
                case 'unit': this.unit = result[1]; break;
                default: console.error('Unknown key: ' + result[0]);
            }
        }
    }

    /**
     *
     * @returns {{}}
     */
    generateProductObject() {
        return {};
    }

    /**
     *
     * @returns {{}}
     */
    generateImportObject() {
        return {
            'type': this.type,
            'code': this.code,
            'brand': this.brand,
            'name': this.name,
            'amount': this.amount,
            'quantity': this.quantity,
            'unit': this.unit,
            'nutrients': this.nutrients,
            'ingredients': this.ingredients,
            'traces': this.traces,
            'stores': this.stores,
            'labels': this.labels,
            'images': this.images
        };
    }

    /**
     *
     * @returns {{}}
     */
    generateInsertObject() {
        for(let index=0; index<this.ingredients.length; index++) {
            this.ingredients[index]['language'] = 'en';
            this.ingredients[index]['proportion'] = '' === this.ingredients[index]['proportion'] ? null : this.ingredients[index]['proportion'];
        }

        for(let index=0; index<this.labels.length; index++) {
            this.labels[index]['language'] = 'en';
            this.labels[index]['hierarchy'] = this.labels.length + 1;
        }

        for(let index=0; index<this.nutrients.length; index++) {
            this.nutrients[index]['language'] = 'en';
        }

        return {
            'type': this.type,
            'code': this.code,
            'brands': [{'name': this.brand, 'rank': 1}],
            'name': this.name,
            'amount': this.amount,
            'quantity': this.quantity,
            'unit': this.unit,
            'ingredients': this.ingredients,
            'traces': this.traces,
            'stores': this.stores,
            'labels': this.labels,
            'images': this.images,
            'food': {
                'alcohol': 0,
                'caffeine': null,
                'nutriscore': null,
                'novagroup': null,
                'cocoa': null,
                'carbonfootprint': null,
                'nutrients': this.nutrients
            }
        };
    }
}

export default Product;